import React, { FC } from 'react'
import styled from 'styled-components'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from 'src/../tailwind.config'
import { IImage } from 'src/components/parallax-image'
import tw from 'twin.macro'
import clsx from 'clsx'

const tailwind = resolveConfig(tailwindConfig);

const MainHeaderWrapper  = styled.div<IMainHeaderBgProp>`
  ${({ bgPic}) => bgPic ? `background-image: url('${bgPic}');` : ''}
  ${tw`md:bg-none`}
`

const MainHeaderH1 = styled.h1`
  font-size: 2rem;
  font-size: clamp(2rem, 10vw, 3.5rem);
  transform: translateY(-1.72vw);
  max-width: 100%;
  ${tw`inline font-roag text-left font-black italic uppercase leading-none m-auto`}

  @media (min-width: ${tailwind.theme.screens.sm}) {
    font-size: 3.5rem;
  }
  @media (min-width: ${tailwind.theme.screens.md}) {
    transform: translateY(0);
    ${tw`text-7xl inline-block mt-16 mb-8`}
  }
  @media (min-width: ${tailwind.theme.screens.xl}) {
    font-size: 5rem;
    font-size: clamp(4.5rem, 6vw, 6.25rem);
  }
`

export interface IPageTitleData {
  pageTitleLine1Margin?: number | null;
  pageTitleLine2Margin?: number | null;
  mobilePageTitleLine1Margin?: number | null;
  mobilePageTitleLine2Margin?: number | null;
  pageTitleLine1: string;
  pageTitleLine2: string;
  mobilePageTitleLine1: string;
  mobilePageTitleLine2: string;
  mobileHeaderImage?: IMobileHeaderImage[];
}

interface IMobileHeaderImage {
  title: string;
  content: string;
  mobileImage: IImage;
}

interface IPageTitleWrapperProps {
  pageTitleData: IPageTitleData
  className?: string
}
interface IMainHeaderBgProp {
  bgPic?: string
}

const getMarginStyle = (marginLeftEm: number | null | undefined) => 
  marginLeftEm ? { marginLeft: `${marginLeftEm}em`} : {}

const PageTitleWrapper: FC<IPageTitleWrapperProps> = ({
  pageTitleData,
  className,
}) => {
  return (
    <div className={className}>
      <MainHeaderWrapper 
        bgPic={pageTitleData.mobileHeaderImage?.[0]?.mobileImage?.url} 
        className={clsx(
          'flex bg-center bg-cover text-center px-4 sm:px-8 md:min-h-0 md:bg-transparent md:h-auto',
          pageTitleData.mobileHeaderImage ? 'bg-almostBlackBlue min-h-[66vw] h-[82vw]' : 'mt-16 md:mt-0',
        )}
      >
        <MainHeaderH1 
          className={pageTitleData.mobileHeaderImage 
            ? 'text-white md:text-almostBlackBlue' 
            : 'text-almostBlackBlue'
          }
        >
          <span 
            className='hidden md:block' 
            style={getMarginStyle(pageTitleData.pageTitleLine1Margin)}
          >{pageTitleData.pageTitleLine1}</span> 
          {pageTitleData.pageTitleLine2 
            ? (<span 
                className='hidden md:block' 
                style={getMarginStyle(pageTitleData.pageTitleLine2Margin)}
              >{pageTitleData.pageTitleLine2}</span>
            ) 
            : null
          }
          <span 
            className='block w-max max-w-full md:hidden' 
            style={getMarginStyle(pageTitleData.mobilePageTitleLine1Margin)}
          >{pageTitleData.mobilePageTitleLine1}</span>
          {pageTitleData.mobilePageTitleLine2 
            ? (<span 
              className='block w-max md:hidden' 
              style={getMarginStyle(pageTitleData.mobilePageTitleLine2Margin)}
            >{pageTitleData.mobilePageTitleLine2}</span>) : (null)}
        </MainHeaderH1>
      </MainHeaderWrapper>
      {pageTitleData.mobileHeaderImage?.[0]?.content 
        ? (
          <div className='bg-almostBlackBlue text-center md:hidden pt-10 pb-12'>
              <div className='text-lg text-appGreen tracking-wide uppercase font-black italic w-2/3 m-auto mb-4'>
                {pageTitleData.mobileHeaderImage[0].title}
              </div>
              <div className='text-base text-white italic w-3/4 sm:w-2/3 m-auto'>
                {pageTitleData.mobileHeaderImage[0].content}
              </div>
          </div>
        ) 
        : null
      }
    </div>
  )
}


PageTitleWrapper.defaultProps = {
    // className: '',
}

export default PageTitleWrapper
